import { Link } from 'react-router-dom';
import { MessageCircle, ArrowUpRight } from 'lucide-react';
import { site } from '../data/site';
import { Reveal } from './Reveal';

export const CTASection = ({
  title = "Let's Build Your Success Story.",
  copy = "Have a business to grow, a brand to build, or a digital project in mind? Tell us what you're working on — let's explore how TheBigHub can help.",
}) => (
  <section data-testid="cta-section" className="grain relative overflow-hidden bg-forest">
    <div
      className="pointer-events-none absolute -left-32 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full bg-emerald-500/30 blur-[110px]"
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute -right-32 top-0 h-[420px] w-[420px] rounded-full bg-[radial-gradient(circle_at_center,rgba(217,70,239,0.22),transparent_65%)] blur-3xl"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
        <div className="max-w-2xl">
          <Reveal>
            <p className="eyebrow mb-5 text-goldlight">Your Move</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="text-balance font-display text-4xl font-bold leading-[1.08] text-white sm:text-5xl lg:text-6xl">
              {title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white sm:text-lg">{copy}</p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row lg:flex-col">
          <Link to="/contact" data-testid="cta-contact-button" className="btn-mint w-full sm:w-auto">
            Let's Grow Your Business <ArrowUpRight size={17} />
          </Link>
          <a
            href={site.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-button"
            className="btn-outline-light w-full sm:w-auto"
          >
            <MessageCircle size={17} /> Talk to Us on WhatsApp
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
